/**
 * basic-aggregation-requests.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

abstract class BasicAggregationRequest extends ReplyVerifyingMessage
{
  /**
   * Construct a new {@link BasicAggregationRequest}.
   */
  constructor (public aggregationId : number)
  {
    super();
  }
}

export class DeleteAggregatorRequest extends BasicAggregationRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_DELETE_AGGREGATOR;
}

export class PauseAggregatorRequest extends BasicAggregationRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_PAUSE_AGGREGATOR;
}

export class ResumeAggregatorRequest extends BasicAggregationRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_RESUME_AGGREGATOR;
}

export class CancelAggregationRequest extends BasicAggregationRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CANCEL_AGGREGATION;
}

export class AggregatorStatusRequest extends BasicAggregationRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_STATUS_AGGREGATOR;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_STATUS_AGGREGATOR);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/basic-aggregation-requests.ts